<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount, watch, toRefs } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import TextBox from "../../compositions/TextBox.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import PharmacyGroupListComponent from "../Common/PharmacyGroupListComponent.vue";
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import { useChatStore } from '../../stores/chat';

const chat = useChatStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    targetPharmacy:{
      type:Object,
      default:() => {
        return null;
      },
    },
})

const { targetPharmacy } = toRefs(props);
const listPharmacyGroupRef = ref();
const listRef = ref();
const isChatDialogShow = ref(false);
const isPharmacyDialogShow = ref(false);
const isSendLoading = ref(false);
const selectPharmacyId = ref(0);
const sendMessage = ref('');
const onChangeSendMessage = (value) => {
  sendMessage.value = value;
}
const chatId = ref(0);
const isChatExpand = ref(false);
const isPharmacyFix = ref(false);
const toPharmacyName = ref('送信先選択');
const toPharmacyTelephone = ref('');
const toPharmacyFax = ref('');
const toPharmacyBusinessHour = ref('');
const optionFields = reactive({
  to_pharmacy_id:selectPharmacyId.value
});
const listGroupSearch = (delay=0) => {
  listPharmacyGroupRef.value.resetItem(delay);
}
const listSearch = (delay=0) => {
  optionFields.to_pharmacy_id = selectPharmacyId.value;
  listRef.value.resetItem(delay);
}
const chatIconClick = () => {
  isChatDialogShow.value = !isChatDialogShow.value;
}
const chatDialogClose = () => {
  isChatDialogShow.value = false;
}

const showPharmacyDialog = () => {
  isPharmacyDialogShow.value = true;
}
const closePharmacyDialog = () => {
  isPharmacyDialogShow.value = false;
}

const commitPharmacy = (item:Object) => {
  selectPharmacyId.value = item.id;
  toPharmacyName.value = item.pharmacy_name;
  toPharmacyTelephone.value = item.pharmacy_telephone;
  toPharmacyFax.value = item.pharmacy_fax;
  toPharmacyBusinessHour.value = item.pharmacy_business_hour;
  listSearch();
  closePharmacyDialog();
}

const sendUserChat = async () => {
  if (sendMessage.value.length == 0) {
    errorAlert('送信内容を入力してください');
    return;
  }
  if (selectPharmacyId.value == 0) {
    errorAlert('送信先薬局を選択してください');
    return;
  }

  isSendLoading.value = true;
  let params = {
    to_pharmacy_id:selectPharmacyId.value,
    content:sendMessage.value,
  };
  try {
    let response = await axios(props.apis.user_update_chat,{method:"post",data:params});
    if (response.status == 200) {
      //新規追加の場合は行が増える場合があるのでリロードする
      if (!isPharmacyFix.value && props.targetPharmacy == null) {
        listGroupSearch(config.LIST_DELAY);
      }
      isPharmacyFix.value = true;
      sendMessage.value = '';
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isSendLoading.value = false;
  }
}

const updatePharmacyPermission = async (id,allowPharmacyId,deleted) => {
  let params = new FormData();
  params.append('allow_pharmacy_id', allowPharmacyId);
  params.append('deleted', deleted);
  try {
    let response = await axios(props.apis.pharmacy_update_pharmacy_permission,{method:"post",data:params});
    if (response.status == 200) {
      let item = listPharmacyGroupRef.value.getItemById(id);
      item.current_is_pharmacy_permission = !item.current_is_pharmacy_permission;
      listPharmacyGroupRef.value.updateItem(item);
    }
  } finally {
    isSendLoading.value = false;
  }
}

const selectPharmacyBox = (item) => {
  isPharmacyFix.value = false;
  selectPharmacyId.value = 0;
  toPharmacyName.value = '送信先選択';
  toPharmacyTelephone.value = '';
  toPharmacyFax.value = '';
  toPharmacyBusinessHour.value = '';
  if (item != null) {
    isPharmacyFix.value = true;
    selectPharmacyId.value = item.to_pharmacy_id;
    toPharmacyName.value = item.pharmacy_name;
    toPharmacyTelephone.value = item.pharmacy_telephone;
    toPharmacyFax.value = item.pharmacy_fax;
    toPharmacyBusinessHour.value = item.pharmacy_business_hour;
  }
  optionFields.to_pharmacy_id = selectPharmacyId.value;
  isChatExpand.value = true;
  listSearch();
}
const closeChatWindow = () => {
  isChatExpand.value = false;
}
const chatReset = () => {
  //
}
const chatResponseComplete = (response) => {
  let item = listPharmacyGroupRef.value.getItemById(selectPharmacyId.value,'to_pharmacy_id');
  if (item != null) {
    item.unread_count = response.unread_count;
    listPharmacyGroupRef.value.updateItem(item);
  }
}
const chatPharmacyGroupReset = () => {
  //
}
watch(targetPharmacy,(newValue,oldValue) => {
  if (newValue != null) {
    commitPharmacy(newValue);
    isPharmacyFix.value = true;
    isChatExpand.value = true;
  }
});
onMounted(() => {
  if (props.targetPharmacy != null) {
    commitPharmacy(props.targetPharmacy);
    isPharmacyFix.value = true;
    isChatExpand.value = true;
  }
});
</script>

<style scoped>
.dli-chevron-round-left {
  display: inline-block;
  vertical-align: middle;
  color: #333;
  line-height: 1;
  position: relative;
  width: 1em;
  height: 1em;
  transform: translateX(25%) rotate(-135deg);
  cursor:pointer;
}

.dli-chevron-round-left::before, .dli-chevron-round-left::after {
  content: '';
  position: absolute;
  background: currentColor;
  border-radius: 0.1em;
}

.dli-chevron-round-left::before {
  top: 0;
  left: 0;
  right: 0;
  height: 0.1em;
}

.dli-chevron-round-left::after {
  top: 0;
  right: 0;
  bottom: 0;
  width: 0.1em;
}
.balloon-div {
  min-width:60%;
}
.balloon-left {
  margin: 0 0 0 0.8em;
  background-color: #e0edff;
  padding: 0.8em;
  border-radius: 0.8em;
  position:relative;
  width:92%;
}

.balloon-left:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -25px;
  margin-top: -15px;
  border: 15px solid transparent;
  border-right: 15px solid #e0edff;
}

.balloon-right {
  margin: 0;
  background-color: #e0edff;
  padding: 0.8em;
  border-radius: 0.8em;
  position:relative;
  width:95%;
}

.balloon-right:before {
  content: "";
  position: absolute;
  top: 50%;
  right: -20px;
  margin-top: -15px;
  border: 15px solid transparent;
  border-left: 15px solid #e0edff;
}
</style>
<template>
<div ref="element">
  <!-- Apps -->
  <button type="button" data-dropdown-toggle="apps-dropdown" class="relative p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100" @click="chatIconClick">
    <span class="sr-only">チャットを見る</span>
    <!-- Icon -->
    <img class="w-6 h-6" src="../../../public/images/icon/btn_message.svg" alt="notice">
    <div id="chat_unread_count" style="display:none;" class="inline-flex absolute -top-1 -right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"></div>
  </button>
  <modal-dialog
    :is-hide-overlay="true"
    :is-overlay-close="false"
    :is-draggable="true"
    :is-just-fit="true"
    :is-visible="isChatDialogShow"
    :close="chatDialogClose"
  >
    <template v-slot:header>
      チャット
    </template>
    <template v-slot:default>
    <div class="p-3">
      <div class="flex">
        <div v-show="targetPharmacy == null" class="flex-row pr-1 border-r-2">
          <custom-list
            ref="listPharmacyGroupRef"
            :is-searchable="true"
            place-holder="薬局名を入力してください"
            :api-url="apis.user_chat_pharmacy_group_list"
            :reset="chatPharmacyGroupReset"
            width="15rem"
            height="23rem"
          >
          <template v-slot:item="slotProps">
            <div class="w-full relative">
              <div :class="'w-full ' + (selectPharmacyId == slotProps.item.to_pharmacy_id ? 'font-bold' : '')" @click="selectPharmacyBox(slotProps.item)">
                {{ slotProps.item.pharmacy_name }}　
                <a v-show="slotProps.item.current_is_share_privated && slotProps.item.is_group == false" @click.stop="updatePharmacyPermission(slotProps.item.id,slotProps.item.to_pharmacy_id,slotProps.item.current_is_pharmacy_permission)" href="javascript:void(0)" :class="'px-2 text-xs border rounded ' + (slotProps.item.current_is_pharmacy_permission ? 'border-red-700 text-red-700 hover:bg-red-100' : 'border-blue-700 text-blue-700 hover:bg-blue-100')">{{ (slotProps.item.current_is_pharmacy_permission ? '承認解除' : '承認') }}</a>
                <div>最終更新：{{ slotProps.item.recent_updated_at }}</div>
              </div>
              <div v-show="slotProps.item.unread_count > 0" class="inline-flex absolute -top-1 -right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-orange-500 rounded-full border-2 border-white dark:border-gray-900">{{ slotProps.item.unread_count }}</div>
            </div>
          </template>
          </custom-list>
          <button type="button" @click="selectPharmacyBox(null)" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">新規追加</button>
        </div>
        <div v-show="isChatExpand && targetPharmacy == null" @click="closeChatWindow" class="flex-row flex items-center pl-1"><span class="dli-chevron-round-left"></span></div>
        <div v-show="isChatExpand" class="flex-row pl-1">
          <custom-list
            ref="listRef"
            :is-searchable="true"
            place-holder="検索ワードを入力してください"
            :top="true"
            :option-fields="optionFields"
            :is-custom-design="true"
            :api-url="apis.user_chat_list"
            :is-overflow-x="false"
            :reset="chatReset"
            :response-complete="chatResponseComplete"
            width="40rem"
            height="15rem"
          >
          <template v-slot:item="slotProps">
            <div :class="'flex items-start ' + (slotProps.item.is_self ? 'justify-end' : 'justify-start')">
              <div class="flex flex-col mb-2 balloon-div">
                <div class="text-xs">{{ slotProps.item.from_pharmacy.pharmacy_name }}:{{ slotProps.item.from_user.username }}</div>
                <div :class="'crlf-area text-base ' + (slotProps.item.is_self ? 'balloon-right' : 'balloon-left')">{{ slotProps.item.content }}</div>
                <div v-show="slotProps.item.is_self" class="text-xs">{{ slotProps.item.is_readed ? '既読' : '未読' }}</div>
                <div v-if="slotProps.item.is_self" class="text-xs">{{ slotProps.item.is_readed ? slotProps.item.updated_at : '' }}</div>
                <div v-else class="text-xs">{{ slotProps.item.created_at }}</div>
              </div>
            </div>
          </template>
          </custom-list>
          <div class="mt-1 flex rounded-md shadow-sm">
            <span class="inline-flex items-center px-3 text-2xl text-gray-500"><i class="fa-solid fa-store"></i></span>
            <button type="button" @click="showPharmacyDialog" :disabled="isPharmacyFix" :class="(isPharmacyFix ? '' : 'focus:outline-none hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 ') + 'w-full py-2.5 px-5 mr-2 mb-2 text-sm font-medium text-gray-900 bg-white rounded-full border border-gray-200 '">{{ toPharmacyName }}</button>
          </div>
          <div class="mt-1 flex rounded-md shadow-sm">
            <span class="inline-flex items-center px-3 text-sm text-gray-500">{{ (toPharmacyTelephone ? 'TEL:' + toPharmacyTelephone : '' ) }}</span>
            <span class="inline-flex items-center px-3 text-sm text-gray-500">{{ (toPharmacyFax ? 'FAX:' + toPharmacyFax : '') }}</span>
          </div>
          <div v-show="toPharmacyBusinessHour" class="mb-2 rounded-md shadow-sm">
            <div><span class="inline-flex items-center px-3 text-sm text-gray-500 crlf-area">{{ (toPharmacyBusinessHour ? '営業時間:' + toPharmacyBusinessHour : '') }}</span></div>
          </div>
          <div class="mb-2 mt-1 flex rounded-md shadow-sm">
            <text-box
              :value="sendMessage"
              :is-focus-clear="false"
              type="textarea"
              :on-change="onChangeSendMessage"
              :text-area-rows="4"
              placeholder="送信内容を入力してください"
            ></text-box>
            <span v-if="!isSendLoading" class="cursor-pointer inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500" @click="sendUserChat"><i class="fa-regular fa-paper-plane"></i></span>
            <div v-else class="flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500" style="color: white;"><img src="../../../public/images/loading.gif"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  </modal-dialog>
  <modal-dialog
    :is-visible="isPharmacyDialogShow"
    :close="closePharmacyDialog"
  >
    <template v-slot:header>
      送信薬局選択
    </template>
    <template v-slot:default>
    <div class="mb-6">
      <pharmacy-group-list-component
        :apis="apis"
        :on-select-pharmacy="commitPharmacy"
      ></pharmacy-group-list-component>
    </div>
  </template>
  </modal-dialog>
</div>
</template>

